var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFooterFixedYoutube = function SvgIconFooterFixedYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M15.314 4.608a1.77 1.77 0 0 0-1.243-1.246c-1.095-.294-5.491-.294-5.491-.294s-4.393 0-5.491.294a1.77 1.77 0 0 0-1.243 1.246C1.553 5.707 1.553 8 1.553 8s0 2.293.293 3.391a1.77 1.77 0 0 0 1.243 1.246c1.098.294 5.491.294 5.491.294s4.396 0 5.491-.294a1.77 1.77 0 0 0 1.243-1.246c.293-1.098.293-3.391.293-3.391s0-2.293-.293-3.392"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.176 10.113 10.827 8 7.176 5.886z"
  })));
};
export default SvgIconFooterFixedYoutube;